import axios from 'axios';

export default {
    getTimeline(jobId, limit) {
        return axios.post(window.API_BASE + '/get-timeline', {
            job_id: jobId,
            limit: limit
        });
    }
}